import script from "./DocView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocView.vue?vue&type=script&setup=true&lang=ts"

import "./DocView.vue?vue&type=style&index=0&id=c22cc3b6&scoped=true&lang=css"
import "./DocView.vue?vue&type=style&index=1&id=c22cc3b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c22cc3b6"]])

export default __exports__